module.exports = __webpack_public_path__ + "static/media/YM88_1.8be0f4ba.jpg";